const AUTH_TOKEN_KEY = "bharatsite_auth_token";

export function getStoredAuthToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY) || "";
}

export function setStoredAuthToken(token) {
    if (!token) return;
    localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearStoredAuthToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem("bharatsite_user");
}
